import React, { memo } from 'react';
import { useTheme } from 'emotion-theming';
export var BlockMonogramPiece1 = /*#__PURE__*/memo(function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#003B5C' : _ref$color,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 536.5 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 600 : _ref$width;

  var _useTheme = useTheme(),
      white = _useTheme.colors.white;

  return /*#__PURE__*/React.createElement("svg", {
    width: width,
    height: height,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 232.2 207.9",
    style: {
      enableBackground: 'new 0 0 232.2 207.9'
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    style: {
      display: 'none'
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    fill: color,
    points: "93.5,208.2 153,208.2 232.2,208.2 232.2,0 199,0 33.1,0 0,0 0,208.2 33.1,208.2"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: white,
    d: "M101,61.9v22.7c0,2.4,0,4.2-1.1,14.4h0.2c3.3-7.7,9.6-11.9,19-11.9c13,0,21.7,9.8,21.7,25.7 c0,19.2-10.5,33.1-31.4,33.1c-8.3,0-18.8-2-23.5-4.7V72.8h-8.6v-11L101,61.9L101,61.9z M100.7,131.5c2.1,1.2,6.2,2,9.6,2 c9.9,0,15.6-8,15.6-19.1c0-9.6-4.2-15.1-12.2-15.1c-8.3,0-12.9,5.6-12.9,13.9L100.7,131.5L100.7,131.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: white,
    cx: "152.9",
    cy: "136.6",
    r: "9.7"
  })))));
});